import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GetSplitMyPartyAccInfo } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import LineBtn from "../../../Button/LineBtn";
import DotStatus from "../../../DefaultStyles/DotStatus";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import { useNavigate } from "react-router-dom";
import AlimTalkModal from "../../AlimTalk/AlimTalkModal";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { recentChatBtnClick } from "../ChatInfo/ChatSearch/ChatSearchResult";
import { authType } from "../../../../pages/Login";
import { AxiosRequestConfig } from "axios";
import { chatTabState } from "../ChatInfo/ChatTab";
import Flex from "../../../DefaultStyles/Flex";
import { PartyOwnerTag } from "./PartyDetailMemberHistory";
import dayjs from "dayjs";
import LmsModal from "../../Message/LmsModal";
import AgreeHistoryBtn from "./PartyDetailMemberInfo/AgreeHistoryBtn";
import LinkidEmailItem from "./PartyDetailMemberInfo/LinkidEmailItem";
import PartyExitBtn from "./PartyDetailMemberInfo/PartyExitBtn";
import { uplusInfoFilterState } from "../../../../pages/Party/UplusMatchingInfo";
import AlertModal from "../../../Modal/AlertModal";
import {
  getMyPartyStatusText,
  getPartyRegState,
} from "../../../../AdminApi/commFunc";
import { decryptPW } from "../../../../ApiTS/ApiCommonTS";
import NetflixExtraPwResetModal from "./NetflixExtraPwResetModal/NetflixExtraPwResetModal";
import {
  getShareDefData,
  GetSubscriptionSetData_V3,
} from "../../../../ApiTS/ServiceDatasTS_V3";
import MacroStateModal from "./MacroStateModal/MacroStateModal";
import NetflixExtraAccModal from "./NetflixExtraAccModal/NetflixExtraAccModal";
import { secodaryMailConverter } from "../../../../scCommon/scCommonFunc";
import NetflixExtraPwRegisterModal from "./NetflixExtraPwRegisterModal/NetflixExtraPwRegisterModal";
import ShareIDChangeModal from "./ShareIDChangeModal/ShareIDChangeModal.tsx";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../AdminApi/3.0_utils";
import PartyAlarmModal from "./PartyAlarmInfo/PartyAlarmModal";
import InviteLinkModal from "./InviteLinkModal/InviteLinkModal";
import ExtrainfoChangeModal from "./ShareIDChangeModal/ExtrainfoChangeModal.tsx copy";
import PartyInviteRegChangeModal from "../PartyInvite/PartyInviteRegChangeModal";
import AutoExtendModal from "./AutoExtendModal/AutoExtendModal";
import { getYTStateString } from "../../../../pages/Party/YoutubeMatchingInfo";

interface PartyDetailMemberInfoProps {
  partyId?: string;
  subsId: number;
  data?: {
    owner?: string;
    servsubsid?: number;
    startdate?: string;
    enddate?: string;
    partyid?: string;
    maxmemb?: number;
    members?: number;
    parentPid?: number;
    ownerPayday?: number;
    extendRevDate?: string;
  };
  fetchData: (params: AxiosRequestConfig<any>) => Promise<void>;
  saveCurrentMember: (memberData: IPartyDetailMemberInfo[]) => void;
}

export interface IPartyDetailMemberInfo {
  grade: number;
  uid: string;
  name: string;
  nickname: string;
  shareid: string;
  joindate: string;
  jointime: string;
  paydate: string;
  birthday: string;
  payday: number;
  exit?: string;
  mstate: number;
  shareinfoUpdate?: string;
  needreg?: number;
  isOld?: number;
  deposit?: number;
  ishide?: number;
  pindex?: number;
  extrainfo?: string;
  ownerid: number;
  uplus_birth?: string;
  uplus_code?: string;
  uplus_name?: string;
  uplus_phone?: string;
  uplus_status?: number;
  mystate: number;
  macro?: number;
  linkidmail?: string;
  auto_extending?: number;
  extendRevDate?: string;
}

export default function PartyDetailMemberInfo({
  partyId,
  subsId,
  data,
  fetchData,
  saveCurrentMember,
}: PartyDetailMemberInfoProps) {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const setTab = useSetRecoilState(chatTabState);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);
  const setUplusInfoFilter = useSetRecoilState(uplusInfoFilterState);

  const subsData = GetSubscriptionSetData_V3(subsId ?? 0);
  const shareDefData = subsData
    ? getShareDefData(subsData?.SHARDEF_ID!, 0)
    : undefined;

  const svcid = subsData?.SVC_ID;

  const isOpenID = shareDefData?.SHARDEF_TYP?.includes("open");
  const isRegisterId = shareDefData?.SHARDEF_TYP === "register_id";
  const isInviteMail = shareDefData?.SHARDEF_TYP === "invite_mail";
  const isSecondaryMail = shareDefData?.SHARDEF_TYP === "invite_2ndry";
  const isInviteExtra =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_extra" ||
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP ===
      "invite_lkdextra";
  const isInviteLink =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_link";
  const isUplus = subsData?.SVC_ID === 90000;

  const isInviteLkdMail =
    getShareDefData(subsData?.SHARDEF_ID!, 0)?.SHARDEF_TYP === "invite_lkdmail";

  console.log(shareDefData);

  const [cannotExitModal, setCannotExitModal] = useState(false);
  const [sendTalkModal, setSendTalkModal] = useState(false);
  const [sendLmsModal, setSendLmsModal] = useState(false);
  const [getAlarmListModal, setgetAlarmListModal] = useState({
    visible: false,
    uid: 0,
    partyid: 0,
  });
  const [netflixExtraAccModal, setNetflixExtraAccModal] = useState({
    modal: false,
    pw: "",
    uid: 0,
    email: "",
    nickname: "",
    name: "",
    linkidmail: "",
    shareid: "",
    extrainfo: "",
  });
  const [netflixExtraPwResetModal, setNetflixExtraPwResetModal] = useState({
    modal: false,
    uid: 0,
  });

  const [shareIDChangeModal, setShareIDChangeModal] = useState({
    modal: false,
    shareid: "",
    uid: 0,
  });
  const [extraInfoChangeModal, setExtraInfoChangeModal] = useState({
    modal: false,
    extrainfo: "",
    uid: 0,
  });

  const [netflixExtraPwRegistModal, setNetflixExtraPwRegistModal] = useState({
    modal: false,
  });
  const [viewData, setViewData] = useState({
    user: "",
    template: "",
    subsData: "",
    partyId: "",
    grade: 0,
  });
  const [macroStateModal, setMacroStateModal] = useState({
    modal: false,
    uid: 0,
    nickname: "",
    name: "",
    macro: 0,
  });
  const [getPassword, setGetPassword] = useState(false);
  const [account, setAcount] = useState("");
  const [inviteLinkModal, setInviteLinkModal] = useState({
    modal: false,
    uid: 0,
  });
  const [autoExtendModal, setAutoExtendModal] = useState({
    modal: false,
    uid: 0,
    nickname: "",
    name: "",
    grade: 0,
    autoExtending: 0,
    extendRevDate: data?.extendRevDate ?? "",
  });

  const [needregChangeModal, setNeedregChangeModal] = useState({
    modal: false,
    cur_needreg: 1,
    uid: 0,
  });

  const { response, fetchData: memberFetchData } = useApi({
    method: "get",
    url:
      auth?.partyInfo && subsData
        ? isUplus
          ? `uplus2/${partyId}/users/0?page=0&size=5`
          : `party/${partyId}/users/0?page=0&size=100`
        : undefined,
  });

  const { response: pwRes } = useApi({
    method: "get",
    url:
      getPassword && netflixExtraAccModal.uid > 0
        ? `party/${partyId}/extraPw/${netflixExtraAccModal.uid}?email=${netflixExtraAccModal.email}`
        : undefined,
  });

  const hasRealName = Boolean(
    shareDefData?.LDR_NM || getShareDefData(subsData?.SHARDEF_ID!, 1)?.MBR_NM,
  );

  const hasProfileName = Boolean(
    shareDefData?.LDR_SVCNM ||
    getShareDefData(subsData?.SHARDEF_ID!, 1)?.MBR_SVCNM,
  );

  const hasProfileNumber = subsData?.SVC_ID === 3100;
  const isTvingAdd = subsData?.SVC_ID === 410;
  const isYoutubeW = subsData?.SVC_ID === 3800;
  const isYoutube = subsData?.SVC_ID === 3700;
  const isGPTSolo = subsData?.SVC_ID === 2850;
  const isGrokSolo = subsData?.SVC_ID === 5050;
  const isPerplexitySolo = subsData?.SVC_ID === 2950;

  const flexibleHeader = [
    isInviteMail ? "링키드 이메일" : isSecondaryMail ? "신메일" : undefined,
    (isRegisterId || isInviteMail) && !isYoutubeW ? "등록 이메일" : undefined,
    // isInviteExtra || isInviteLkdMail || isTvingAdd ? "계정 정보" : undefined,
    // "계정정보",
    isYoutubeW ? "국가" : undefined,
    isInviteLink ? "초대 링크" : undefined,
    isOpenID || isYoutube || isGPTSolo || isGrokSolo || isPerplexitySolo ? undefined : "등록 상태",
    isInviteExtra ? "매크로 상태" : undefined,
    hasProfileNumber ? "사용 프로필" : undefined,
    hasProfileName && !hasProfileNumber ? "프로필 이름" : undefined,
    hasRealName ? "실명" : undefined,
    isRegisterId || isInviteMail ? "정보 변경 일시" : undefined,
    isGPTSolo || isYoutube || isGrokSolo || isPerplexitySolo ? "접수 상태" : undefined,
  ];

  const uplusFlexibleHeader = [
    "휴대폰 번호",
    "이름",
    "생년월일",
    "결합 코드",
    "상세",
  ];

  const partyInfoHeader = [
    "UID_이름_닉네임",
    "계정정보",
    "자동연장",
    ...(isUplus ? uplusFlexibleHeader : flexibleHeader),
    "상태",
    "가입일",
    "정산일",
    "동의 내역",
    "채팅",
    "알림톡",
    "LMS",
    "해산/탈퇴",
  ];

  useEffect(() => {
    if (response?.status === 200) {
      saveCurrentMember(response?.data?.items);
    }
  }, [response]);

  useEffect(() => {
    if (pwRes?.status === 200) {
      setNetflixExtraAccModal((prev) => ({
        ...prev,
        ...(pwRes?.data?.email && pwRes?.data?.email?.length
          ? { email: pwRes?.data?.email }
          : {}),
        ...(pwRes?.data?.pw && pwRes?.data?.pw?.length
          ? {
              pw: decryptPW(
                pwRes?.data?.pw,
                netflixExtraAccModal.uid,
              )?.replaceAll('"', ""),
            }
          : {}),
      }));

      setGetPassword(false);
    }
  }, [pwRes]);

  return (
    <>
      <Table tableHeadData={partyInfoHeader} tableMinWidth={1055}>
        <>
          {response?.data?.items?.map((d: IPartyDetailMemberInfo) => {
            const account =
              GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id === "" ||
              !GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id
                ? secodaryMailConverter(
                    data?.owner,
                    subsData?.SVC_ID,
                    d?.pindex,
                  )
                : GetSplitMyPartyAccInfo(d?.shareid ?? "")?.id;

            console.log(account);

            return (
              <TableBody key={d?.uid}>
                <TableBodyItem isKeepAll={true}>
                  <Flex gapSize={6}>
                    <LineBtn
                      icon="notifications"
                      btnClickEvent={() => {
                        setViewData({
                          ...viewData,
                          user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                          subsData: `${subsId}_${getString3ByKey(
                            GetSubscriptionSetData_V3(subsId)?.SUBS_NM ?? 0,
                          )}`,
                          partyId: partyId!,
                          grade: d?.grade,
                        });
                        setgetAlarmListModal({
                          visible: true,
                          partyid: Number(partyId)!,
                          uid: Number(d?.uid),
                        });
                      }}
                      sPadding="0 7px"
                      disabled={!auth?.kakao}
                    />
                    <Member onClick={() => navigate(`/users/info/${d?.uid}`)}>
                      {d?.uid}_{d?.name}_{d?.nickname}
                    </Member>
                    <>
                      {d?.grade === 0 ? (
                        <PartyOwnerTag>파티장</PartyOwnerTag>
                      ) : d?.isOld === 1 ? (
                        <OldMemberTag>연장</OldMemberTag>
                      ) : d?.grade === 2 ? (
                        <PartyOwnerTag>위임</PartyOwnerTag>
                      ) : null}
                    </>
                  </Flex>
                </TableBodyItem>

                {/* 계정 정보 */}
                {/* {(isInviteExtra || isInviteLkdMail || isTvingAdd) && ( */}
                <TableBodyItem>
                  <LineBtn
                    btnText={"보기"}
                    // disabled={d?.grade !== 1 ? true : false}
                    disabled={false}
                    btnClickEvent={() => {
                      setNetflixExtraAccModal((prev) => ({
                        ...prev,
                        modal: true,
                        pw: "",
                        uid: +d?.uid,
                        nickname: d?.nickname,
                        name: d?.name,
                        extrainfo: d?.extrainfo!,
                        email: account,
                        linkidmail: d?.linkidmail!,
                        shareid: d?.shareid,
                      }));
                      setGetPassword(true);
                    }}
                  />
                </TableBodyItem>
                {/* )} */}

                {/* 자동연장 */}
                <TableBodyItem>
                  <LineBtn
                    btnColor={d?.auto_extending === 1 ? "mint" : undefined}
                    btnText={d?.auto_extending === 1 ? "On" : "Off"}
                    disabled={false}
                    btnClickEvent={() => {
                      setAutoExtendModal({
                        modal: true,
                        uid: +d?.uid,
                        nickname: d?.nickname,
                        name: d?.name,
                        grade: d?.grade,
                        autoExtending: d?.auto_extending ?? 0,
                        extendRevDate: data?.extendRevDate ?? "",
                      });
                    }}
                  />
                </TableBodyItem>

                <>
                  {isUplus ? (
                    <>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_phone ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_name ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_birth ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem isKeepAll={true}>
                        {d?.uplus_code ?? "-"}
                      </TableBodyItem>
                      <TableBodyItem>
                        <LineBtn
                          btnText="보기"
                          btnClickEvent={() => {
                            setUplusInfoFilter((prev) => ({
                              ...prev,
                              searchType: "uid",
                              searchValue: d?.uid,
                            }));
                            navigate(`/party/uplus`);
                          }}
                          disabled={!(d?.uid && +d?.uid > 0)}
                        />
                      </TableBodyItem>
                    </>
                  ) : (
                    <>
                      {isOpenID || isYoutube || isGPTSolo || isGrokSolo || isPerplexitySolo ? null : (
                        <>
                          {/* 링키드 이메일 */}
                          {(isInviteMail || isSecondaryMail) && (
                            <LinkidEmailItem
                              partyId={partyId}
                              subsId={subsId}
                              d={d}
                            />
                          )}

                          {/* 초대 링크 */}
                          {isInviteLink && (
                            <TableBodyItem>
                              <LineBtn
                                btnText={"보기"}
                                disabled={
                                  d?.grade !== 1 || d?.needreg !== 0
                                    ? true
                                    : false
                                }
                                btnClickEvent={() =>
                                  setInviteLinkModal({
                                    uid: +d?.uid,
                                    modal: true,
                                  })
                                }
                              />
                            </TableBodyItem>
                          )}

                          {isYoutubeW ? (
                            <TableBodyItem>
                              {d?.extrainfo
                                ? (JSON.parse(d?.extrainfo)?.country ?? "-")
                                : "-"}
                            </TableBodyItem>
                          ) : null}

                          {/* 등록 이메일 */}
                          {(isRegisterId || isInviteMail) && !isYoutubeW && (
                            <TableBodyItem>{account}</TableBodyItem>
                          )}

                          {/* 등록 상태 */}
                          <TableBodyItem isKeepAll>
                            <LineBtn
                              btnText={getPartyRegState(
                                d?.grade,
                                d?.needreg!,
                                d?.macro,
                              )}
                              disabled={d?.grade === 0 ? true : false}
                              btnClickEvent={() =>
                                setNeedregChangeModal({
                                  cur_needreg: +d?.needreg!,
                                  uid: +d?.uid,
                                  modal: true,
                                })
                              }
                            />
                            {/* {getPartyRegState(d?.grade, d?.needreg!, d?.macro)} */}
                          </TableBodyItem>

                          {/* 매크로 상태 */}
                          {isInviteExtra ? (
                            <TableBodyItem>
                              <LineBtn
                                btnText="보기"
                                btnClickEvent={() =>
                                  setMacroStateModal({
                                    modal: true,
                                    macro: d?.macro ?? 0,
                                    name: d?.name,
                                    nickname: d?.nickname,
                                    uid: +d?.uid,
                                  })
                                }
                              />
                            </TableBodyItem>
                          ) : null}

                          {/* 프로필 이름 */}
                          {hasProfileName ? (
                            <TableBodyItem>
                              {GetSplitMyPartyAccInfo(d?.shareid ?? "")
                                ?.profileName !== ""
                                ? GetSplitMyPartyAccInfo(d?.shareid ?? "")
                                    ?.profileName
                                : "-"}
                            </TableBodyItem>
                          ) : null}

                          {/* 실명 */}
                          {hasRealName ? (
                            <TableBodyItem>
                              {d?.extrainfo
                                ? (JSON.parse(d?.extrainfo)?.name ?? "-")
                                : "-"}
                            </TableBodyItem>
                          ) : null}

                          {/* 정보 변경 일시 */}
                          {!(
                            isOpenID ||
                            isSecondaryMail ||
                            isInviteExtra ||
                            isInviteLink ||
                            isInviteLkdMail
                          ) ? (
                            <TableBodyItem>
                              {d?.shareinfoUpdate
                                ? dayjs(d?.shareinfoUpdate)?.format(
                                    "YYYY-MM-DD HH:mm",
                                  )
                                : "-"}
                            </TableBodyItem>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>

                {/* 프로필 번호 */}
                {hasProfileNumber ? (
                  <TableBodyItem>
                    {d?.pindex ? d?.pindex : "-"} 번
                  </TableBodyItem>
                ) : null}



                {/* 접수상태 */}
                {d?.extrainfo && (isGPTSolo || isYoutube || isGrokSolo || isPerplexitySolo) ? (
                  <TableBodyItem>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "16px",
                          fontSize: "13px",
                          fontWeight: 600,
                          backgroundColor:
                            JSON.parse(d?.extrainfo)?.ytstate === 1
                              ? "#FFF3E0"
                              : JSON.parse(d?.extrainfo)?.ytstate === 2
                                ? "#E3F2FD"
                                : JSON.parse(d?.extrainfo)?.ytstate === 3
                                  ? "#E8F5E9"
                                  : JSON.parse(d?.extrainfo)?.ytstate === 4 ||
                                      JSON.parse(d?.extrainfo)?.ytstate === 5
                                    ? "#FFEBEE"
                                    : "#F5F5F5",
                          color:
                            JSON.parse(d?.extrainfo)?.ytstate === 1
                              ? "#E65100"
                              : JSON.parse(d?.extrainfo)?.ytstate === 2
                                ? "#1565C0"
                                : JSON.parse(d?.extrainfo)?.ytstate === 3
                                  ? "#2E7D32"
                                  : JSON.parse(d?.extrainfo)?.ytstate === 4 ||
                                      JSON.parse(d?.extrainfo)?.ytstate === 5
                                    ? "#C62828"
                                    : "#616161",
                        }}
                      >
                        {JSON.parse(d?.extrainfo)?.ytstate
                          ? getYTStateString(
                              JSON.parse(d?.extrainfo)?.ytstate ?? "-",
                            )
                          : "-"}
                      </span>
                    </div>
                  </TableBodyItem>
                ) : null}

                <TableBodyItem>
                  <DotStatus
                    text={getMyPartyStatusText(d?.mystate).text}
                    color={getMyPartyStatusText(d?.mystate).color}
                    size="sm"
                  />
                </TableBodyItem>

                <TableBodyItem>{d?.joindate}</TableBodyItem>

                <TableBodyItem>{d?.payday}일</TableBodyItem>

                {/* 동의 내역 */}
                <TableBodyItem>
                  <AgreeHistoryBtn d={d} data={data} />
                </TableBodyItem>

                {/* 채팅 보내기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="chat"
                    btnClickEvent={() => {
                      setTab(1);
                      setRecentBtnClick(true);

                      navigate({
                        pathname: `/party/chat`,
                        search: `${partyId}@${data?.owner}@${d?.uid}`,
                      });
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.chat || d?.grade === 0}
                  />
                </TableBodyItem>

                {/* 알림톡 보내기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="send"
                    btnClickEvent={() => {
                      setAcount(account);
                      setViewData({
                        ...viewData,
                        user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                        subsData: `${subsId}_${getString3ByKey(
                          GetSubscriptionSetData_V3(subsId)?.SUBS_NM ?? 0,
                        )}`,
                        partyId: partyId!,
                        grade: d?.grade,
                      });

                      setSendTalkModal(true);
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.kakao}
                  />
                </TableBodyItem>

                {/* LMS 보내기 */}
                <TableBodyItem>
                  <LineBtn
                    icon="mail"
                    btnClickEvent={() => {
                      setViewData({
                        ...viewData,
                        user: `${d?.uid}_${d?.name}_${d?.nickname}`,
                        subsData: `${subsId}_${getSubsNameBySubsId3(subsId)}`,
                      });

                      setSendLmsModal(true);
                    }}
                    sPadding="0 7px"
                    disabled={!auth?.kakao}
                  />
                </TableBodyItem>

                {/* 해산/탈퇴 */}
                <TableBodyItem>
                  <PartyExitBtn
                    d={d}
                    data={data}
                    subsId={subsId}
                    checkEvent={
                      isUplus &&
                      (d?.grade === 0 || d?.grade === 2) &&
                      data?.members === 1 &&
                      d?.uplus_status === 1
                        ? () => {
                            if (
                              (d?.grade === 0 || d?.grade === 2) &&
                              data?.members === 1 &&
                              d?.uplus_status === 1
                            ) {
                              setCannotExitModal(true);
                            }
                          }
                        : undefined
                    }
                    fetchingEvent={() => {
                      memberFetchData({
                        method: "get",
                        url: isUplus
                          ? `uplus/${partyId}/users/0?page=0&size=5`
                          : `party/${partyId}/users/0?page=0&size=${
                              subsData?.POL_SHARMX ?? 10
                            }`,
                      });

                      fetchData({
                        method: "get",
                        url: `party/${partyId}`,
                      });
                    }}
                  />
                </TableBodyItem>
              </TableBody>
            );
          })}
        </>
      </Table>
      {/* 알림톡 보내기 모달 */}
      {sendTalkModal && (
        <AlimTalkModal
          closeEvent={() => setSendTalkModal(false)}
          type="input"
          viewData={viewData}
          userAccount={account}
        />
      )}
      {/* lms 보내기 모달 */}
      {sendLmsModal && (
        <LmsModal
          closeEvent={() => setSendLmsModal(false)}
          type="input"
          viewData={viewData}
        />
      )}

      {/* 알림 리스트 보기 */}
      {getAlarmListModal.visible && (
        <PartyAlarmModal
          closeEvent={() =>
            setgetAlarmListModal({
              visible: false,
              uid: 0,
              partyid: 0,
            })
          }
          partyid={getAlarmListModal.partyid}
          uid={getAlarmListModal.uid}
        />
      )}
      {cannotExitModal && (
        <AlertModal
          title={"파티를 해산할 수 없습니다."}
          desc={
            "현재 파티장의 결합상태(Y)가 정확한지 유플러스와 크로스체크 후 처리해 주세요."
          }
          customCancelBtn={<></>}
          confirmText="확인"
          btnColor="mint"
          confirmEvent={() => setCannotExitModal(false)}
        />
      )}
      {/* 넷플릭스 추가공유 비밀번호 보기 */}
      {netflixExtraAccModal.modal && (
        <NetflixExtraAccModal
          closeEvent={() =>
            setNetflixExtraAccModal({
              ...netflixExtraAccModal,
              modal: false,
            })
          }
          resetEvent={() =>
            setNetflixExtraPwResetModal({
              modal: true,
              uid: netflixExtraAccModal?.uid,
            })
          }
          changeIdEvent={() => {
            setShareIDChangeModal({
              modal: true,
              shareid: netflixExtraAccModal?.shareid,
              uid: netflixExtraAccModal?.uid,
            });
          }}
          changeExtraInfoEvent={() => {
            setExtraInfoChangeModal({
              modal: true,
              extrainfo: netflixExtraAccModal?.extrainfo,
              uid: netflixExtraAccModal?.uid,
            });
          }}
          registEvent={() =>
            setNetflixExtraPwRegistModal((prev) => ({
              ...prev,
              modal: true,
            }))
          }
          userData={{
            uid: netflixExtraAccModal.uid,
            name: netflixExtraAccModal.name,
            nickname: netflixExtraAccModal.nickname,
          }}
          accData={{
            email: netflixExtraAccModal.email,
            pw: netflixExtraAccModal.pw,
          }}
          svcid={subsData?.SVC_ID!}
        />
      )}
      {/* 넷플릭스 추가공유 비밀번호 설정 모달 */}
      {netflixExtraPwResetModal.modal && (
        <NetflixExtraPwResetModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setNetflixExtraPwResetModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          email={netflixExtraAccModal.email}
          linkidmail={netflixExtraAccModal?.linkidmail}
        />
      )}
      {/* 넷플릭스 추가공유 비밀번호 등록 모달 */}
      {netflixExtraPwRegistModal.modal && (
        <NetflixExtraPwRegisterModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setNetflixExtraPwRegistModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          confirmEvent={() =>
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            })
          }
          email={netflixExtraAccModal.email}
          linkidmail={netflixExtraAccModal?.linkidmail}
        />
      )}

      {/* shareid 변경 모달 */}
      {shareIDChangeModal.modal && (
        <ShareIDChangeModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setShareIDChangeModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          confirmEvent={() =>
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            })
          }
          shareid={netflixExtraAccModal?.shareid}
          extrainfo={netflixExtraAccModal?.extrainfo}
          linkidmail={netflixExtraAccModal?.linkidmail}
        />
      )}

      {/* shareid 변경 모달 */}
      {extraInfoChangeModal.modal && (
        <ExtrainfoChangeModal
          partyId={+partyId!}
          uid={netflixExtraAccModal.uid}
          closeEvent={() =>
            setExtraInfoChangeModal((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          confirmEvent={() =>
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            })
          }
          shareid={netflixExtraAccModal?.shareid}
          extrainfo={netflixExtraAccModal?.extrainfo}
          linkidmail={netflixExtraAccModal?.linkidmail}
        />
      )}

      {/* 매크로 상태 보기 */}
      {macroStateModal.modal && (
        <MacroStateModal
          userData={{
            uid: macroStateModal.uid,
            nickname: macroStateModal.nickname,
            name: macroStateModal.name,
          }}
          macro={macroStateModal.macro}
          closeEvent={() =>
            setMacroStateModal({
              modal: false,
              macro: 0,
              name: "",
              nickname: "",
              uid: 0,
            })
          }
          confirmEvent={() =>
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            })
          }
        />
      )}

      {inviteLinkModal.modal && (
        <InviteLinkModal
          uid={inviteLinkModal.uid}
          closeEvent={() => setInviteLinkModal({ uid: 0, modal: false })}
        />
      )}

      {/* 등록 상태 변경 모달 */}
      {/* 자동연장 설정 모달 */}
      {autoExtendModal.modal && (
        <AutoExtendModal
          partyId={partyId!}
          uid={autoExtendModal.uid}
          nickname={autoExtendModal.nickname}
          name={autoExtendModal.name}
          grade={autoExtendModal.grade}
          currentAutoExtending={autoExtendModal.autoExtending}
          extendRevDate={autoExtendModal.extendRevDate}
          partyEnddate={data?.enddate}
          closeEvent={() =>
            setAutoExtendModal({
              modal: false,
              uid: 0,
              nickname: "",
              name: "",
              grade: 0,
              autoExtending: 0,
              extendRevDate: autoExtendModal.extendRevDate,
            })
          }
          confirmEvent={() => {
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            });
            fetchData({
              method: "get",
              url: `party/${partyId}`,
            });
          }}
        />
      )}

      {needregChangeModal.modal && (
        <PartyInviteRegChangeModal
          data={{
            partyId: partyId!,
            uid: needregChangeModal.uid,
            cur_needreg: needregChangeModal.cur_needreg,
          }}
          closeEvent={() =>
            setNeedregChangeModal({
              modal: false,
              uid: 0,
              cur_needreg: 1,
            })
          }
          confirmEvent={() =>
            memberFetchData({
              method: "get",
              url:
                auth?.partyInfo && subsData
                  ? isUplus
                    ? `uplus2/${partyId}/users/0?page=0&size=5`
                    : `party/${partyId}/users/0?page=0&size=100`
                  : undefined,
            })
          }
        />
      )}
    </>
  );
}

const Member = styled.span`
  cursor: pointer;
  text-decoration: underline;
`;

export const OldMemberTag = styled(PartyOwnerTag)`
  color: ${({ theme }) => theme.buttonColor.linePressed};
`;
